import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class CurrencyDisabledView extends React.Component {
  /** *******************static************************** */
  static propTypes = {
    data: PropTypes.object,
  };

  static defaultProps = {
    data: {}
  };

  /** *******************life cycle************************** */
  constructor(props) {
    super(props);
  }

  /** *******************render************************** */

  formatCcyCode(ccyCode) {
    return ccyCode === 'CNY' ? '￥' : ccyCode;
  }


  render() {
    const { orgCcyCode,orgAmount,baseCcyCode, baseAmount } = this.props.data;
    const { orgAdjustedAmount, baseAdjustedAmount } = this.props.data.value;

    let formatCcyCode = this.formatCcyCode,
        hasAdjusted = orgAmount - orgAdjustedAmount !== 0;

    return (
      <div className="control-view-item">
        <div className="control">
          <div className='multiple-amount'>
            <span><strong>收款：<i>{formatCcyCode(baseCcyCode)}</i></strong>{baseAdjustedAmount}</span>
            { hasAdjusted && (
              <span className='adjusted'><i>{formatCcyCode(baseCcyCode)}</i>{baseAmount}</span>
            ) }
          </div>
          <div className='multiple-amount'>
            <span><span>消费：<i>{formatCcyCode(orgCcyCode)}</i></span>{orgAdjustedAmount}</span>
            { hasAdjusted && (
              <span className='adjusted'><i>{formatCcyCode(orgCcyCode)}</i>{orgAmount}</span>
            ) }
          </div>
        </div>
      </div>
    );
  }
}

export default CurrencyDisabledView;
